<script setup>
import {computed, defineProps} from "vue";

const props = defineProps({
  /**
   * Активная дата.
   * Array - Для range picker
   * Date - для единичного выбора даты.
   */
  selectedDate: {
    type: [Array, Date, null],
    required: true,
  }
});

// Функия форматирования даты dd.mm.yyyy
function formatDate(date) {
  if (!(date instanceof Date)) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
}

// Вычисляемые свойства для вывода
const formattedDateFrom = computed(() => {
  if (Array.isArray(props.selectedDate)) {
    return props.selectedDate[0] instanceof Date
        ? formatDate(props.selectedDate[0])
        : "";
  }
  // single-date mode — выводим саму дату
  return props.selectedDate instanceof Date
      ? formatDate(props.selectedDate)
      : "";
});

const formattedDateTo = computed(() => {
  if (Array.isArray(props.selectedDate)) {
    return props.selectedDate[1] instanceof Date
        ? formatDate(props.selectedDate[1])
        : "";
  }
  // single-date mode — нет второго значения
  return "";
});
</script>

<template>
  <div class="date-view">
    <div class="date-view__item">
      {{ formattedDateFrom }}
    </div>
    <div class="date-view__separator">
      —
    </div>
    <div class="date-view__item">
      {{ formattedDateTo }}
    </div>
  </div>
</template>

<style scoped lang="scss">

.date-view {
  align-items: center;
  display: flex;
  gap: 4px;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid #EEF1F4;

  &__item {
    align-items: center;
    background: #F7F8FD;
    border-radius: 8px;
    box-sizing: border-box;
    color: #373D3F;
    display: flex;
    font-size: 14px;
    font-weight: 400;
    height: 26px;
    justify-content: center;

    padding: 4px 6px;
    width: 100%;
  }
}

</style>